module.exports = __webpack_public_path__ + "media/images/default/lp_top_capture_file2-1613c1418e81574daa587418e65bf231.svg";